import { _get } from "../../http";

export const getLeccionesEditadasPorEditorial = (idEditorial) => {
    return _get(`/historialUma/editorial/${idEditorial}`);
};

export const getHistorialPorLeccion = (idUma, skip = 0, limit = 50) => {
    return _get(`/historialUma/${idUma}?skip=${skip}&limit=${limit}`);
};
